import styled from 'styled-components';

import ErrorMessage, { ErrorMessageWrapper } from '@components/ErrorMessage';
import { ComponentEnhancer, TypeOfPropsFor } from '@utils/types';
import { FormControlLabel } from '@components/ui/form/FormControl';

type ErrorDisplayLayout = {
  layout?: 'row' | 'column';
};
export const Container = styled.div<ErrorDisplayLayout>`
  display: flex;
  flex-direction: ${(p) => p.layout};
  row-gap: 10px;
  column-gap: 15px;
  position: relative;
  &[data-error='true'] {
    ${ErrorMessageWrapper} {
      position: ${(p) => p.layout === 'column' && 'absolute'};
      top: 100%;
    }
  }
`;
type ErrorProps = ErrorDisplayLayout & {
  hasError?: boolean;
  errorMessage?: string;
  errorPropName?: string;
  showErrorIcon?: boolean;
  label?: string;
  labelErrorStyles?: React.CSSProperties;
};
export const FormField: ComponentEnhancer<ErrorProps> = ({
  Component,
  hasError,
  errorMessage,
  errorPropName = 'hasError',
  layout = 'column',
  showErrorIcon = false,
  children,
  label,
  labelErrorStyles,
  ...rest
}) => {
  const errorProps = errorPropName ? { [errorPropName]: hasError } : {};
  const props = { ...rest, ...errorProps } as TypeOfPropsFor<typeof Component>;

  return (
    <Container layout={layout} key='parent' data-error={hasError}>
      {label ? (
        <FormControlLabel data-role='label'>{label}</FormControlLabel>
      ) : null}

      <Component {...props} {...(label ? { label: '' } : {})} />
      {hasError ? (
        <ErrorMessage
          message={errorMessage}
          showIcon={showErrorIcon}
          labelStyle={labelErrorStyles}
        />
      ) : null}
      {children}
    </Container>
  );
};

export default FormField;
